import React from 'react';
import { Dispatch } from 'redux';
import { BreadcrumbModel } from '../../models/breadcrumb.model';
import { ROUTING_HELPER } from '../../utils/routing-helper';

// Create Action Constants
export enum HeaderActionTypes {
    SET_TITLE = 'SET_TITLE',
    SET_BREADCRUMB = 'SET_BREADCRUMB',
    SET_STATUS = 'SET_STATUS',
    SET_ACTIONS = 'SET_ACTIONS',
    HIDE_BREADCRUMB_BAR = 'HIDE_BREADCRUMB_BAR'
}

interface SetTitleAction {
    type: HeaderActionTypes.SET_TITLE;
    value?: string;
}

interface SetBreadcrumbAction {
    type: HeaderActionTypes.SET_BREADCRUMB;
    value: BreadcrumbModel[];
}

interface SetStatusAction {
    type: HeaderActionTypes.SET_STATUS;
    value?: React.ReactNode;
}

interface SetActionsAction {
    type: HeaderActionTypes.SET_ACTIONS;
    value?: React.ReactNode;
}

interface HideBreadcrumbBar {
    type: HeaderActionTypes.HIDE_BREADCRUMB_BAR;
    value?: boolean;
}

export type HeaderActions = SetTitleAction | SetBreadcrumbAction | SetStatusAction | SetActionsAction | HideBreadcrumbBar;

export const hideBreadcrumbBar = (value?: boolean) => (dispatch: Dispatch) => {
    dispatch({
        value: value,
        type: HeaderActionTypes.HIDE_BREADCRUMB_BAR,
    })
}

export const setTitle = (value: string) => (dispatch: Dispatch) => {

    dispatch({
        value: value,
        type: HeaderActionTypes.SET_TITLE,
    })

    const breadCrumb: BreadcrumbModel = {
        title: value,
        href: window.location.pathname + window.location.search
    }

    dispatch({
        value: ROUTING_HELPER.getBreadcrumbs(breadCrumb),
        type: HeaderActionTypes.SET_BREADCRUMB,
    })
}

export const setStatus = (value: React.ReactNode) => (dispatch: Dispatch) => {
    dispatch({
        value: value,
        type: HeaderActionTypes.SET_STATUS,
    })
}

export const setActions = (value: React.ReactNode) => (dispatch: Dispatch) => {
    dispatch({
        value: value,
        type: HeaderActionTypes.SET_ACTIONS,
    })
}